export enum TokenFields {
    name = 'name',
    symbol = 'symbol',
    decimals = 'decimals',
    initialSupply = 'initialSupply'
};

export type CreateTokenType = {
    [TokenFields.name]: String;
    [TokenFields.symbol]: String;
    [TokenFields.decimals]: Number;
    [TokenFields.initialSupply]: Number;
};

export interface TokenBalance {
  token_id: string;
  name: string;
  symbol: string;
  decimals: number;
  balance: number;
  type: 'FUNGIBLE_COMMON' | 'NON_FUNGIBLE_UNIQUE';
}
